var map = {
	"./check.svg": 855,
	"./chrome.svg": 856,
	"./close-gray.svg": 857,
	"./document.svg": 858,
	"./firefox.svg": 859,
	"./icon-check.svg": 860,
	"./icon-feature1.svg": 861,
	"./icon-feature2.svg": 862,
	"./icon-feature3.svg": 863,
	"./icon-tick-blue.svg": 864,
	"./icon-tick-disabled.svg": 865,
	"./icon-tick.svg": 866,
	"./illustration2.svg": 867,
	"./illustration3.svg": 868,
	"./ilus-badge-entry.svg": 869,
	"./ilus-badge-expert.svg": 870,
	"./ilus-badge-journeyman.svg": 871,
	"./ilus-badge-qualified.svg": 872,
	"./left-arrow.svg": 873,
	"./loading.svg": 874,
	"./logo.svg": 875,
	"./logo_dark.svg": 876,
	"./submitting.svg": 877,
	"./ui-kit-svg-sprite.svg": 159
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 854;